const ARROW_MARKER_ID = "arrow-marker";
const NODE_TEST_ID = "node";
const EDGE_TEST_ID = "edge";
const LABEL_TEST_ID = "label";

export { ARROW_MARKER_ID, EDGE_TEST_ID, LABEL_TEST_ID, NODE_TEST_ID };
//# sourceMappingURL=constants.esm.js.map
